var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InputField,{attrs:{"value":_vm.value,"name":"search","label":_vm.$t('common.search'),"placeholder":_vm.$t('form.enter-search'),"reset":_vm.reset,"hide-label":true,"horizontal":true},on:{"input":_setup.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }